import SmallAreaCharts from './SmallAreaCharts';

export default SmallAreaCharts;
